import React from 'react'
import Loading from '@components/SuspenseLoading/Loading'
import {getResizedImageSSR_image} from '@data/queries/components/__generated__/getResizedImageSSR'
import isServerSide from '@helpers/misc/isServerSide'
import roundToNearest from '@helpers/misc/roundToNearest'
import useResizedImageURL from '@hooks/useResizedImageURL'
import useWidth, {DEFAULT_DESKTOP_WIDTH} from '@hooks/useWidth'

import styles from './styles.module.css'

export const justAnImageDefaultOpts = {
  scale: 2,
  width: roundToNearest(DEFAULT_DESKTOP_WIDTH, 200) || 400,
  height: null
}
export interface JustAnImageProps {
  ssrImage?: getResizedImageSSR_image
  smallImage?: any
  image?: any
}

export default function JustAnImage(props: JustAnImageProps) {
  const screenWidth = useWidth()
  const image = screenWidth <= 760 ? props.smallImage || props.image : props.image

  const url = useResizedImageURL(
    {
      ...justAnImageDefaultOpts,
      width: roundToNearest(screenWidth, 200) || 400,
      fileId: image._id
    },
    {partial: true}
  )

  const finalUrl = url ? url : props.ssrImage?.resizedURL
  if (isServerSide() && !props.ssrImage?.resizedURL) {
    console.warn(
      'Could not fetch image for JustAnImage component while doing SSR. This should be fixed for an optimized experience'
    )
    return <Loading />
  }

  return (
    <div className={styles.container}>{finalUrl ? <img src={finalUrl} alt="" /> : <Loading />}</div>
  )
}
